<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
    <router-view v-if="isRouterAlive" name="Slide"></router-view>
    <router-view v-if="isRouterAlive" name="Intro"></router-view>
    <router-view v-if="isRouterAlive" name="Map"></router-view>
    <router-view v-if="isRouterAlive" name="Blog"></router-view>
    <router-view v-if="isRouterAlive" name="BlogPage"></router-view>
    <router-view v-if="isRouterAlive" name="Gallery"></router-view>
    <router-view v-if="isRouterAlive" name="BlogPageDetail"></router-view>
    <router-view v-if="isRouterAlive" name="GalleryDetail"></router-view>
    <router-view v-if="isRouterAlive" name="About"></router-view>
    <router-view v-if="isRouterAlive" name="Comment"></router-view>
    <router-view v-if="isRouterAlive" name="Subscribe"></router-view>
    <router-view v-if="isRouterAlive" name="Manager"></router-view>
    <router-view v-if="isRouterAlive" name="Footer"></router-view>
    <router-view v-if="isRouterAlive" name="Sidemenu"></router-view>
    <router-view v-if="isRouterAlive" name="Activity"></router-view>
    <router-view v-if="isRouterAlive" name="ActivityEdit"></router-view>
    <router-view v-if="isRouterAlive" name="Article"></router-view>
    <router-view v-if="isRouterAlive" name="ArticleEdit"></router-view>
    <router-view v-if="isRouterAlive" name="PrivacyPolicy"></router-view>
  </div>
</template>
<script>
import Header from "./components/Header";
import Slide from "./components/Slide";
import Intro from "./components/Intro";
import Map from "./components/Map";
import Blog from "./components/Blog";
import BlogPage from "@/components/BlogPage";
import BlogPageDetail from "@/components/BlogPageDetail";
import About from "./components/About";
import Comment from "./components/Comment";
import Subscribe from "./components/Subscribe";
import Footer from "./components/Footer";
import Manager from "./components/Manager";
import Gallery from "./components/Gallery";
import GalleryDetail from "./components/GalleryDetail";
import Sidemenu from "@/components/admin-manage/Sidemenu";
import Activity from "@/components/admin-manage/Activity";
import ActivityEdit from "@/components/admin-manage/ActivityEdit";
import Article from "@/components/admin-manage/Article";
import ArticleEdit from "@/components/admin-manage/ArticleEdit";
import PrivacyPolicy from "@/components/PrivacyPolicy";
import axios from "axios";
import VueAxios from "vue-axios";
import route from "@/router/index";
var mylibMain = require("./js/main");
var mylibSlick = require("./js/slick-custom");
export default {
  name: "App",
  components: {
    Header,
    Slide,
    Intro,
    Map,
    Blog,
    BlogPage,
    BlogPageDetail,
    About,
    Comment,
    Subscribe,
    Footer,
    Manager,
    Gallery,
    GalleryDetail,
    Sidemenu,
    Activity,
    ActivityEdit,
    Article,
    ArticleEdit,
    PrivacyPolicy
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      isRouterAlive: true,
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    }
  },
  updated() {
    mylibMain.myfunc();
    mylibSlick.myfunc();
    var evt = document.createEvent("Event");
    evt.initEvent("load", false, false);
    window.dispatchEvent(evt);
    document.getElementById("app").style.backgroundColor = "#ffff";
  }
};
</script>

<style scoped>
#app >>> .bg-title-page {
  background-repeat:no-repeat;
  background-position: center center;
  min-height: 400px;
}
.p-b-20{
  text-decoration:none;
}
@media screen and (max-width: 414px) {
  .bg-title-page {
  background-size: cover;
  min-height: 250px;
}
}
@media screen and (max-width: 320px) {
  .animsition {
    margin-right: -11% !important;
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue